export default function getPrevFilteredItemState() {
    return {
        data: {}
    };
}



// WEBPACK FOOTER //
// ./src/MerchantItems/Reducer/getPrevFilteredItemState.js